import React, {useEffect, useState} from 'react';
import {Modal, Table} from "react-bootstrap";
import BlockUi from "@availity/block-ui";
import axios from "../helpers/axios";
import sayError from "../helpers/sayError";
import {noDispHeader} from "../helpers/errorTranslate";
import _ from "lodash"
import numberFormat from "../helpers/numberFormat";

const BigLogsModal = ({id}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow]=useState(false)
  const [data, setData] = useState()

  useEffect(() => {
    if(show && !data){
      axios.get('/api/logs/'+id,{headers: {...noDispHeader}})
        .then(({data})=>{
          setData(data)
        })
        .catch(sayError)
        .finally(()=>setLoading(false))
    }
  }, [show]);
  const renderLabel = (value) =>{
    return _.find(fields,{value})?.label || value
  }
  const renderValue = (field) =>{
    if(typeof field.oldValue === 'number'){
      return <>
        <td>{numberFormat(field.oldValue)}</td>
        <td>{numberFormat(field.newValue)}</td>
      </>
    }else if(typeof field.newValue === "boolean"){
      return <>
        <td>{field.newValue ? "Нет" : "Да" }</td>
        <td>{field.newValue ? "Да" : "Нет"}</td>
      </>
    }else if(!!field.modelName){
      return <>
        <td>{_.find(data.entities[field.modelName], {id:field.oldValue})?.value || ''}</td>
        <td>{_.find(data.entities[field.modelName], {id:field.newValue}).value}</td>
      </>
    }else{
      return <>
        <td>{field.oldValue}</td>
        <td>{field.newValue}</td>
      </>
    }
  }

  return (
    <>
      <div onClick={() => setShow(true)} style={{cursor: "pointer"}}>
        <i className="fa fa-comments"/>
      </div>
      <Modal show={show} onHide={() => setShow(false)} dialogClassName="modal-90w" >
        <Modal.Header closeButton>
          <Modal.Title>Изменения</Modal.Title>
        </Modal.Header>
        <BlockUi blocking={loading}>
          <Modal.Body>
            {data && <Table bordered size={'sm'}>
              <thead>
              <tr>
                <td style={{width: '2rem'}}>Ресурс</td>
                <td>Дата</td>
                <td>Изменил</td>
                <td>Поле</td>
                <td>Старое значение</td>
                <td>Новое значение</td>
              </tr>
              </thead>
              <tbody>
              {data.logs.map((log,i)=>{
                return<React.Fragment key={i}>
                  <tr style={{backgroundColor: 'rgba(100,108,154,0.32)'}}>
                    <td>{log.source === 'site' ? 'Сайт' : '1C'}</td>
                    <td>{log.createdAt }</td>
                    <td colSpan={4}>{log.user}</td>
                  </tr>
                  {log.changes.map((item,index)=>{
                    return <React.Fragment key={index}>
                      <tr style={{backgroundColor: _.find(fields,{value: item.changeType})?.color}}>
                        <td></td>
                        <td>{renderLabel(item.entityType)}</td>
                        <td>{item.entity}</td>
                        <td colSpan={3}></td>
                    </tr>
                      {item.changedFields.map((field, i)=>{
                        return <tr key={i}>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{renderLabel(field.fieldName)}</td>
                          {renderValue(field)}
                        </tr>
                      })}
                    </React.Fragment>
                  })}

                </React.Fragment>
              })}
              </tbody>
            </Table>}
          </Modal.Body>
        </BlockUi>
      </Modal>
    </>
  );
};

export default BigLogsModal;

const fields = [
  {label:'Билет', value:'TKT'},
  {label:'Билет', value:'RLW'},
  {label:'EMD', value:'EMD'},
  {label:'ЖД Бронь', value:'RWO'},
  {label:'Услуга', value:'SRV'},
  {label:'Бронь', value:'ABK'},
  {label:'Пассажир', value:'mainPax'},
  {label:'Добавлен новый', value:'added', color:'rgba(138,246,113,0.49)'},
  {label:'', value:'edited', color:'rgba(100,108,154,0.10)'},
  {label:'Удален', value:'removed', color:'rgba(246,113,168,0.49)'},
  {label:'Восстановлен', value:'restored', color:'rgba(138,246,113,0.49)'},
  {label:'Комиссия', value:'commission'},
  {label:'КрсКаяр', value:'krsKayar'},
  {label:'Индивидуальный код', value:'idInOneC'},
  {label:'Поставщик', value:'supplierNew'},
  {label:'Валюта', value:'currency'},
  {label:'Курс', value:'exchangeRate'},
  {label:'Дата начала', value:'startDate'},
  {label:'Дата окончания', value:'endDate'},
  {label:'Сумма Вал', value:'summCurrency'},
  {label:'Сумма KZT', value:'summKZT'},
  {label:'Номер билета', value:'ticketNumber'},
  {label:'Авиакомпания', value:'airline'},
  {label:'Номер бронирования', value:'orderNumber'},
  {label:'Дата выписки', value:'issuedDate'},
  {label:'Дата выписки', value:'issueDate'},
  {label:'Выписан', value:'issuedBy'},
  {label:'Пассажир', value:'paxName'},
  {label:'Тариф', value:'fare'},
  {label:'Таксы', value:'taxes'},
  {label:'Штрафы', value:'penalties'},
  {label:'КРС клиента', value:'krsBuyer'},
  {label:'КРС поставщика', value:'krsSeller'},
  {label:'КРС Каяр', value:'krsKayar'},
  {label:'Возврат', value:'refund'},
  {label:'Пред.билет', value:'prevTicket'},
  {label:'Комментарий', value:'serviceComment'},
  {label:'Технический контрагент', value:'technicalCounterparty'},
  {label:'Без документов', value:'issuedWithoutDocs'},
  {label:'ВОИД', value:'isVoid'},
  {label:'Подвязка', value:'tiedUp'},
  {label:'Комментарий подвязки', value:'tiedUpComment'},
  {label:'Номер ЕМД', value:'emdNumber'},
  {label:'КРС', value:'krs'},
  {label:'Альтернативный маршрут', value:'alternativeRoute'},
  {label:'Оплачено', value:'paid'},
  {label:'Покупатель', value:'buyer'},
  {label:'Удалён', value:'isDeleted'}
]
